import api from "../api/client";
const options = {
  endpoint: "api/v1/file",
  baseEndpoint: "api/v1/file",
  data: {},
};
export default {
    DownloadFile(token, data) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.baseEndpoint}/Download`;
        return api.download(options);
    },
}